var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("h5", [_vm._v("Manage links")]),
      _vm._v(" "),
      _c("p", { staticClass: "small text-muted" }, [
        _vm._v(
          "Save changes one connection. Edit shared details separately. Reported links do not establish ownership or authority."
        ),
      ]),
      _vm._v(" "),
      _vm.error
        ? _c(
            "b-alert",
            {
              ref: "errorAlert",
              attrs: { tabindex: "-1", show: "", variant: "danger" },
            },
            [
              _vm._v(_vm._s(_vm.readable(_vm.error.message)) + "\n    "),
              Object.keys(_vm.error.errors || {}).length
                ? _c(
                    "ul",
                    { staticClass: "mb-0" },
                    _vm._l(_vm.error.errors, function (messages, field) {
                      return _c("li", { key: field }, [
                        _vm._v(
                          _vm._s(_vm.label(field)) +
                            ": " +
                            _vm._s(_vm.readable([].concat(messages).join(" ")))
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.error.code === "stale_registry_edit"
                ? _c(
                    "b-btn",
                    {
                      attrs: {
                        size: "sm",
                        variant: "link",
                        disabled: _vm.busy,
                      },
                      on: { click: _vm.reload },
                    },
                    [_vm._v("Discard draft and reload current record")]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.roles.length
        ? _c("p", [
            _vm._v("This record has no editable outgoing relationship roles."),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.links, function (link, index) {
        return _c(
          "div",
          { key: index, staticClass: "border-bottom py-2" },
          [
            _c("div", [
              _vm._v(
                _vm._s(_vm.roleLabel(link.role)) +
                  " · " +
                  _vm._s(_vm.label(link.resolution))
              ),
            ]),
            _vm._v(" "),
            link.resolved
              ? _c(
                  "b-btn",
                  {
                    staticClass: "p-0",
                    attrs: { variant: "link", size: "sm" },
                    on: {
                      click: function ($event) {
                        return _vm.openEntity(link.resolved)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.entityName(link.resolved)))]
                )
              : _c("p", { staticClass: "small mb-1" }, [
                  _vm._v(
                    _vm._s(
                      _vm.readable(_vm.evidenceName(link)) ||
                        "No selected target"
                    )
                  ),
                ]),
            _vm._v(" "),
            link.resolved
              ? _c("div", { staticClass: "small text-muted" }, [
                  _vm._v(_vm._s(_vm.entityAddress(link.resolved))),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              link.reported_relationships || [],
              function (reportedRelationship) {
                return _c(
                  "div",
                  {
                    key: reportedRelationship.reported_relationship_key,
                    staticClass: "small mt-1",
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          reportedRelationship.reported_relationship_key.startsWith(
                            "admin:"
                          )
                            ? "Added by administrator"
                            : "Supplier connection"
                        ) +
                        " · " +
                        _vm._s(_vm.label(reportedRelationship.resolution)) +
                        "\n      "
                    ),
                    !reportedRelationship.asserted_by_source &&
                    !reportedRelationship.reported_relationship_key.startsWith(
                      "admin:"
                    )
                      ? _c("span", [_vm._v(" · No longer reported")])
                      : _vm._e(),
                    _vm._v(" "),
                    reportedRelationship.correction
                      ? _c("span", [
                          _vm._v(
                            " · " +
                              _vm._s(
                                _vm.readable(
                                  reportedRelationship.correction.reason
                                )
                              ) +
                              " · " +
                              _vm._s(
                                _vm.dateTime(
                                  reportedRelationship.correction.set_at
                                )
                              )
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        !reportedRelationship.reported_relationship_key.startsWith(
                          "admin:"
                        )
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "p-0 mr-3",
                                attrs: {
                                  type: "button",
                                  size: "sm",
                                  variant: "link",
                                  disabled: !_vm.canUpdate || _vm.busy,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.choose(
                                      link,
                                      reportedRelationship,
                                      "target"
                                    )
                                  },
                                },
                              },
                              [_vm._v("Choose target")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !reportedRelationship.reported_relationship_key.startsWith(
                          "admin:"
                        )
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "p-0 mr-3",
                                attrs: {
                                  type: "button",
                                  size: "sm",
                                  variant: "link",
                                  disabled: !_vm.canUpdate || _vm.busy,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.choose(
                                      link,
                                      reportedRelationship,
                                      "suppress"
                                    )
                                  },
                                },
                              },
                              [_vm._v("Suppress connection")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        reportedRelationship.correction
                          ? _c(
                              "b-btn",
                              {
                                staticClass: "p-0",
                                attrs: {
                                  type: "button",
                                  size: "sm",
                                  variant: "link",
                                  disabled: !_vm.canUpdate || _vm.busy,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.choose(
                                      link,
                                      reportedRelationship,
                                      "restore"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    reportedRelationship.reported_relationship_key.startsWith(
                                      "admin:"
                                    )
                                      ? "Remove added link"
                                      : "Use source relationship"
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }
            ),
            _vm._v(" "),
            _c(
              "details",
              { staticClass: "small mt-1" },
              [
                _c("summary", [_vm._v("Source evidence and candidates")]),
                _vm._v(" "),
                _vm._l(link.candidates || [], function (candidate) {
                  return _c(
                    "div",
                    { key: `${candidate.type}:${candidate.id}` },
                    [
                      _vm._v(
                        _vm._s(_vm.label(candidate.type)) +
                          " candidate: " +
                          _vm._s(_vm.entityName(candidate)) +
                          " · " +
                          _vm._s(_vm.entityAddress(candidate))
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("pre", { staticClass: "registry-link-evidence" }, [
                  _vm._v(_vm._s(_vm.evidence(link.evidence || {}))),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            link.role === "location" &&
            !link.resolved &&
            link.source_record_id &&
            link.evidence
              ? _c(
                  "b-btn",
                  {
                    attrs: {
                      type: "button",
                      variant: "link",
                      size: "sm",
                      disabled: !_vm.canUpdate || _vm.busy,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.createFromEvidence(link)
                      },
                    },
                  },
                  [_vm._v("Add location from this evidence")]
                )
              : _vm._e(),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "b-form",
        {
          staticClass: "mt-3",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "fieldset",
            { attrs: { disabled: _vm.busy || !_vm.canUpdate } },
            [
              _c(
                "b-form-group",
                {
                  attrs: { label: "Relationship", "label-for": _vm.id("role") },
                },
                [
                  _c("b-form-select", {
                    key: _vm.controlVersion,
                    attrs: {
                      id: _vm.id("role"),
                      value: _vm.form.role,
                      options: _vm.roles.map((value) => ({
                        value,
                        text: _vm.roleLabel(value),
                      })),
                    },
                    on: { change: _vm.changeRole },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.form.reportedRelationship
                ? _c("p", { staticClass: "small" }, [
                    _vm._v(
                      _vm._s(
                        _vm.form.operation === "restore"
                          ? "Restore current supplier behavior, or remove this administrator-added link."
                          : _vm.form.operation === "suppress"
                          ? "Keep the supplier reportedRelationship as evidence with explicitly no target."
                          : "Correct this supplier reportedRelationship to exactly one typed target."
                      )
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.form.operation === "target" && _vm.roles.length
                ? [
                    _vm._l(_vm.candidates, function (candidate) {
                      return _c(
                        "div",
                        {
                          key: `${candidate.type}:${candidate.id}`,
                          staticClass: "mb-2",
                        },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: {
                                checked: _vm.form.target && _vm.form.target.id,
                                name: _vm.id("candidate"),
                                value: candidate.id,
                              },
                              on: {
                                change: function ($event) {
                                  _vm.form.target = candidate
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.label(candidate.type)) +
                                  " candidate: " +
                                  _vm._s(_vm.entityName(candidate)) +
                                  " · " +
                                  _vm._s(_vm.entityAddress(candidate))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _c("RegistryActionTargetPicker", {
                      attrs: { types: _vm.allowedTypes },
                      model: {
                        value: _vm.form.target,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "target", $$v)
                        },
                        expression: "form.target",
                      },
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.allowedTypes, function (type) {
                      return _c(
                        "b-btn",
                        {
                          key: type,
                          attrs: {
                            type: "button",
                            variant: "link",
                            size: "sm",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.startCreate(type)
                            },
                          },
                        },
                        [_vm._v("Add " + _vm._s(type))]
                      )
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.creating
                ? _c(
                    "div",
                    { staticClass: "border rounded p-3 my-3" },
                    [
                      _c("h6", [_vm._v("Add " + _vm._s(_vm.newEntity.type))]),
                      _vm._v(" "),
                      _c("RegistryActionEntityFields", {
                        model: {
                          value: _vm.newEntity,
                          callback: function ($$v) {
                            _vm.newEntity = $$v
                          },
                          expression: "newEntity",
                        },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "small" }, [
                        _vm._v(
                          "Create the record, then save the link separately. Matching supplier links resolve automatically."
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Creation reason",
                            "label-for": _vm.id("create-reason"),
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: { id: _vm.id("create-reason") },
                            model: {
                              value: _vm.creationReason,
                              callback: function ($$v) {
                                _vm.creationReason =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "creationReason",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { type: "button", variant: "outline-primary" },
                          on: { click: _vm.createTarget },
                        },
                        [_vm._v("Save new record")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { type: "button", variant: "link" },
                          on: { click: _vm.cancelCreate },
                        },
                        [_vm._v("Cancel new record")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.createdNotice
                ? _c(
                    "p",
                    {
                      staticClass: "small text-success",
                      attrs: { role: "status" },
                    },
                    [_vm._v(_vm._s(_vm.createdNotice))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  staticClass: "mt-3",
                  attrs: { label: "Reason", "label-for": _vm.id("reason") },
                },
                [
                  _c("b-form-textarea", {
                    attrs: { id: _vm.id("reason"), rows: "2", required: "" },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.form,
                          "reason",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c(
                "b-btn",
                {
                  staticClass: "mr-2",
                  attrs: {
                    type: "button",
                    variant: "outline-secondary",
                    disabled: _vm.busy,
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: {
                    type: "submit",
                    variant: "primary",
                    disabled:
                      !_vm.canUpdate ||
                      _vm.busy ||
                      !_vm.dirty ||
                      _vm.creating ||
                      !_vm.roles.length,
                  },
                },
                [_vm._v(_vm._s(_vm.busy ? "Saving..." : "Save"))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }